export default "__VITE_ASSET__318046dc__"